import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from "services/PubSub";
import CMSFactory from 'factories/CMS';
import style from './style.scss';//NOSONAR

const Countdown = ({ dateEnd, serverDate, timerId, color }) => {
    const endDate = CMSFactory.milliseconds(dateEnd);
    const difference = endDate - serverDate;
    const [timer, setTimer] = useState(difference > 0 ? difference : 0);
    const [hour, setHour] = useState('0');
    const [min, setMin] = useState('0');
    const [sec, setSec] = useState('0');

    
    let timeout = null;

    useEffect(() => {
        timeout = setTimeout(() => updateTimer(), 1000);
        return function cleanup() {
            clearTimeout(timeout);
        };
    });

    const updateTimer = () => {
        if (timer <= 0){
            PubSub.dispatch('banner-timer-show', { timerId });
            return false;
        } 

        const seconds = Math.floor((timer / 1000) % 60);
        const minuts = Math.floor((timer / 1000 / 60) % 60);
        const hours = Math.floor(timer / 1000 / 60 / 60);

        const addZeroInLeft = (data) => {
            return data.toString().length < 2 ? '0' + data.toString() : data;
        };

        setHour(addZeroInLeft(hours));
        setMin(addZeroInLeft(minuts));
        setSec(addZeroInLeft(seconds));

        setTimer(timer - 1000);
    };

    return (
        <div className={"countdown" + (color ? ' light' : ' ')}>
            <div className="countdown-wrapper">
                <span className="countdown-digit">{hour}</span>
                <span className="countdown-label">Horas</span>
            </div>
            <div className="countdown-two-points">:</div>
            <div className="countdown-wrapper">
                <span className="countdown-digit">{min}</span>
                <span className="countdown-label">Minutos</span>
            </div>
            <div className="countdown-two-points">:</div>
            <div className="countdown-wrapper">
                <span className="countdown-digit">{sec}</span>
                <span className="countdown-label">Segundos</span>
            </div>
        </div>
    );
};

Countdown.propTypes = {
    dateEnd: PropTypes.string,
    serverDate: PropTypes.number,
    timerId: PropTypes.string,
    color: PropTypes.bool
};

export default Countdown;
